// VISTA SIN COSTOS (ADENDA A0b, decisión de Diego del 11-oct, MANDA): "me gustaría ver en cuántos centavos por watt
// estamos cotizando, y yo poder ver los márgenes; mi equipo no, solo yo ver márgenes y utilidad esperada".
// El SERVIDOR pasa por aquí TODA respuesta para quien no tiene el permiso `ver_costos` (http/registro.ts): no basta con
// esconderlo en la pantalla. Se quita, en cualquier lugar de la respuesta:
//  - la rentabilidad de cada opción y de cada nivel de baterías (costo, desglose de costo, utilidad, margen, comisión);
//  - el costo para Solarix de cada costo adicional (queda null: "no lo ves");
//  - el margen y la utilidad de la recomendada en el registro del CRM (Cotizacion.margen_pct / utilidad_sin_iva);
//  - el texto de la revisión de rentabilidad con IA (trae utilidad y margen) y los avisos de esa revisión con cifras;
//  - el aviso COSTO_SIN_CONFIRMAR (es de Diego: habla de sus costos) y el amarillo de MARGEN_BAJO (zona de alerta);
//  - sin `{ semaforo: true }`, el aviso SEMAFORO_CAMBIO (el semáforo cambió de color al recalcular: es semáforo);
//  - la comisión de cada vendedor (lista de usuarios) y la de la cotización (parámetros);
//  - VERDE DE ENTRADA (2-nov): el precio sin la regla (`limites_precio.contado_sin_regla`) y lo que subió cada precio
//    (`resultado.minimos_verde`, `parametros.verde_congelado`);
//  - OPTIMUS (Diego, 12-oct noche: la comisión desglosada "nunca visible para vendedores"): la casilla de Optimus de cada
//    usuario y el precio de Optimus congelado de la cotización (trae las comisiones y el factor);
//  - AMPLIACIÓN DE BATERÍAS (27-oct): de `calculo_piezas`, el costo, la comisión, los imprevistos, la utilidad, el margen, la regla
//    y el costo de cada partida (calculoSinCostos: el costo de la batería de tabla es de Diego);
//  - AMPLIACIÓN DE BATERÍAS, verificación de ventas del 27-oct: los costos que TECLEÓ el vendedor (`piezas`: el costo de proveedor
//    de la batería con su fuente, material, instalación y viáticos) solo los ve el vendedor de ESA cotización (y Diego). En una
//    ajena van en null, sus ediciones del historial sin antes ni después y sus avisos sin cifras (`quien`, que pasa el servidor);
//  - del historial, las cifras de las ediciones a la comisión de la cotización (/parametros/comision_pct), en todos los tipos;
//  - ADENDA z59: el resumen de la LISTA DE COMPRA de una Ganada (`lista_compra`: meta, costo cotizado, techo; P2: Hiram, Nubia
//    y los vendedores no ven precio de venta ni margen, y la hoja solo la baja Diego por su ruta con `ver_costos`);
//  - del historial, el detalle de las revisiones con IA y las cifras de margen de las aprobaciones viejas (y, sin
//    `{ semaforo: true }`, el renglón "Semáforo de margen al recalcular: …" de un evento);
//  - de los avisos del generador (y de los renglones del .avisos.txt y las notas del JSON v1 que se bajan por la ruta de
//    archivos: notaSoloDirector), la revisión de rentabilidad, COSTO_SIN_CONFIRMAR y el amarillo de margen; sin
//    `{ semaforo: true }`, también el cambio de color del semáforo (verificación adversarial de la etapa 2: se colaban ahí).
// Es una función pura de JSON a JSON (no sabe de rutas): una ruta nueva queda cubierta sola. La interfaz NUNCA calcula
// costos: si un campo falta, no lo enseña.
//
// SEMÁFORO (Diego, 11-oct, MANDA sobre lo anterior): "que lo vean Miguel y Juan Carlos pero que no vean porcentajes, solo
// color de semáforo". Con `{ semaforo: true }` (asesores internos: permiso `ver_semaforo`), cada opción o nivel cuya
// rentabilidad se quita conserva SOLO su color en `semaforo_margen`, y el registro del CRM conserva `semaforo_margen`. Sin
// él (externos, y lo que se le pasa a la IA), no queda ningún color: ni `semaforo_margen` en ningún lugar de la respuesta.

import { calculoSinCostos } from './dominio/ampliacion-baterias.ts';
import type { CalculoAmpliacion } from './dominio/ampliacion-baterias.ts';

const ETIQUETA_OPCION_VISTA: Readonly<Record<string, string>> = Object.freeze({ arranque: 'Arranque', exacta: 'Exacta', holgada: 'Holgada' });

const RESUMEN_REVISION: Readonly<Record<string, string>> = Object.freeze({
  bien: 'La revisión de precio no encontró problemas.',
  revisar: 'La revisión de precio encontró algo que revisar: el detalle de costos y margen lo ve Diego.',
  pierde_dinero: 'Este precio necesita el OK de Diego.',
});

const CIFRA = /[$%]|\d[\d,.]*\s*(pesos|mxn|usd)/i;

/** El semáforo dicho en TEXTO (no en un campo): el código del aviso o "semáforo de margen". */
const SEMAFORO_EN_TEXTO = /SEMAFORO_CAMBIO|sem[aá]foro de margen/i;
/** El amarillo de margen ("zona de alerta") y el aviso de costos sin confirmar, dichos en texto. */
const MARGEN_EN_TEXTO = /COSTO_SIN_CONFIRMAR|zona de alerta|Aviso amarillo · MARGEN_BAJO|queda [\d.,]+ % arriba de/i;
/** VERDE DE ENTRADA (2-nov): cuánto subió un precio, dicho en TEXTO. Con el % y el contado se saca `contado_sin_regla`, que es solo de Diego: el vendedor lee el aviso sin la cifra. */
const SUBIDA_DE_ENTRADA = /queda [\d.,]+ % arriba de /;
/** Verificación adversarial del 14-oct (ADENDA l: pocos avisos): las notas del motor que son SOLO para Diego empiezan con
 *  «Para Diego:» (p. ej. cuánto costaría el respaldo con una marca cuya garantía falta en la plantilla). Van en los supuestos
 *  del resultado y en el .avisos.txt («Supuesto del cálculo: Para Diego: …»); a nadie más le llegan. */
const PARA_DIEGO = /(^|\] |Supuesto del cálculo: )Para Diego:/;

/** Etapa 2 (verificación adversarial, 12-oct): ¿este renglón que el generador guardó con la cotización (avisos_generador de
 *  una versión, renglón del .avisos.txt o nota interna del JSON v1) es solo de Diego? La revisión de rentabilidad con IA, el
 *  aviso de costos sin confirmar y el amarillo de margen ("zona de alerta"), siempre; el cambio de color del semáforo, salvo
 *  con `{ semaforo: true }` (asesores internos: ven el color). La usan vistaSinCostos (respuestas de la API) y la ruta de
 *  archivos (lo que baja el vendedor): un solo criterio para los dos caminos. */
export function notaSoloDirector(texto: string, opciones: { semaforo?: boolean } = {}): boolean {
  if (/Revisión de rentabilidad|de la revisión de rentabilidad/i.test(texto) || MARGEN_EN_TEXTO.test(texto) || PARA_DIEGO.test(texto)) return true;
  return opciones.semaforo !== true && SEMAFORO_EN_TEXTO.test(texto);
}

/** Etapa 2: el cambio de color del semáforo al recalcular queda en el historial ("Semáforo de margen al recalcular: Exacta
 *  de verde a amarillo."). Solo colores; vistaSinCostos lo quita del evento a quien no ve el semáforo (externos). */
export function textoSemaforoEnHistorial(cambios: readonly string[]): string {
  return cambios.length ? ` Semáforo de margen al recalcular: ${cambios.join('; ')}.` : '';
}
const SEMAFORO_EN_HISTORIAL = / Semáforo de margen al recalcular: [^.]*\./g;

type Json = unknown;
type Obj = Record<string, unknown>;

const esObj = (x: Json): x is Obj => typeof x === 'object' && x !== null && !Array.isArray(x);

/** ¿Este objeto es un costo adicional de la cotización? */
const esCostoAdicional = (o: Obj) => 'precio_cliente_sin_iva' in o && 'capturado_por' in o && 'costo_solarix_sin_iva' in o;
/** ¿Es un aviso? */
const esAviso = (o: Obj) => typeof o['codigo'] === 'string' && typeof o['nivel'] === 'string' && typeof o['origen'] === 'string' && typeof o['mensaje'] === 'string';
/** ¿Es un evento del historial? */
const esEvento = (o: Obj) => typeof o['tipo'] === 'string' && typeof o['detalle'] === 'string' && 'cotizacion_id' in o && 'en' in o;
/** ¿Es la revisión de rentabilidad guardada en el borrador? */
const esRevisionIA = (o: Obj) => typeof o['veredicto'] === 'string' && typeof o['resumen'] === 'string' && 'revisado_en' in o;

/** Un aviso del costo tecleado de una ampliación ajena (el costo de proveedor con su cifra y su fuente): sin cifras. */
function avisoPiezasSinCifras(a: Obj): Obj {
  if (!CAMPO_COSTO_PIEZAS.test(String(a['campo'] ?? '')) || !(CIFRA.test(String(a['mensaje'])) || AVISO_COSTO_PIEZAS.test(String(a['mensaje'])))) return a;
  return { ...a, mensaje: a['nivel'] === 'rojo' ? 'Hay que revisar el costo de la batería: lo corrige el vendedor de esta cotización (o Diego).' : 'El costo de la batería es de la cotización de un proveedor: la cifra la ven el vendedor de esta cotización y Diego.' };
}

function avisoSinCifras(a: Obj): Obj {
  if (a['origen'] === 'motor' && SUBIDA_DE_ENTRADA.test(String(a['mensaje']))) return { ...a, mensaje: String(a['mensaje']).replace(SUBIDA_DE_ENTRADA, 'queda arriba de ') };
  if (a['origen'] !== 'ia_revision') return a;
  const mensaje = String(a['mensaje']);
  if (!CIFRA.test(mensaje)) return a;
  const opcion = typeof a['opcion'] === 'string' ? (ETIQUETA_OPCION_VISTA[a['opcion']] ?? a['opcion']) : null;
  const quien = opcion ? `${opcion}: ` : '';
  const codigo = String(a['codigo']);
  let texto: string;
  if ((codigo === 'PIERDE_DINERO' || codigo === 'MARGEN_BAJO') && a['nivel'] === 'rojo') texto = `${quien}este precio necesita el OK de Diego.`;
  else if (codigo === 'MARGEN_BAJO') texto = `${quien}el margen de este precio queda en la zona de alerta. Revisa antes de bajarlo más.`;
  else texto = `${quien}la revisión de precio levantó un aviso; el detalle de costos lo ve Diego.`;
  return { ...a, mensaje: texto };
}

function eventoSinCifras(e: Obj, conSemaforo: boolean): Obj {
  if (!conSemaforo) {
    const sinSemaforo = String(e['detalle']).replace(SEMAFORO_EN_HISTORIAL, '');
    if (sinSemaforo !== e['detalle']) e = { ...e, detalle: sinSemaforo };
  }
  if (e['tipo'] === 'revision_ia') {
    const m = /^Revisión de rentabilidad con IA: ([^.]+)\./.exec(String(e['detalle']));
    return { ...e, detalle: `Revisión de rentabilidad con IA${m ? `: ${m[1]}` : ''}. El detalle lo ve Diego.` };
  }
  if (e['tipo'] === 'aprobacion') return { ...e, detalle: String(e['detalle']).replace(/\s*\(margen [^)]*\)/gi, '').replace(/,?\s*margen\s+-?[\d.,]+\s*%/gi, '') };
  return e;
}

/** ¿Es una edición (historial o propuesta de la IA)? */
const esEdicion = (o: Obj) => typeof o['ruta'] === 'string' && typeof o['op'] === 'string';
/** ¿Es una edición (historial o propuesta de la IA) del costo para Solarix de un adicional, o de la comisión (o el precio de
 *  Optimus) de la cotización? Son de Diego: sin antes ni después (verificación del 27-oct: la comisión salía en el historial). */
const esEdicionDeCosto = (o: Obj) => esEdicion(o) && /^\/costos_adicionales\/\d+\/costo_solarix_sin_iva$|^\/parametros\/(comision_pct|precio_optimus)(\/|$)/.test(String(o['ruta']));
/** Los costos que teclea el vendedor en una ampliación: la captura completa (/piezas) o uno de sus costos. */
const RUTA_COSTO_PIEZAS = /^\/piezas(\/costo_[^/]+(\/.*)?)?$/;
/** Los avisos de esos costos (el costo de proveedor con su cifra y su fuente) y sus renglones en lo que dejó el generador. */
const CAMPO_COSTO_PIEZAS = /^\/piezas\/costo_/;
const AVISO_COSTO_PIEZAS = /Costo de la batería tecleado|El costo de proveedor/;
const COSTOS_PIEZAS = ['costo_material_sin_iva', 'costo_instalacion_sin_iva', 'costo_viaticos_sin_iva'] as const;

/** La captura de una ampliación sin los costos que tecleó su vendedor (para quien no ve costos y no es su vendedor). El costo
 *  «de la tabla» no trae cifra: se queda (dice de dónde sale, no cuánto). Todos estos campos ya son nullable en el esquema. */
function piezasSinCostos(p: Obj): Obj {
  const o: Obj = { ...p };
  for (const k of COSTOS_PIEZAS) if (k in o) o[k] = null;
  const cb = o['costo_bateria'];
  if (esObj(cb) && cb['origen'] !== 'tabla') o['costo_bateria'] = null;
  return o;
}

/** Contexto de la limpieza: el semáforo (internos), quién pide y si la cotización que se está limpiando es SUYA (sus costos
 *  de piezas). Sin `usuario` (lo que se le pasa a la IA, el servidor simulado de antes) no se mira de quién es. */
interface Opc {
  semaforo: boolean;
  usuario: string | null;
  propia: boolean;
}

const COLORES: readonly string[] = ['verde', 'amarillo', 'rojo'];

function limpiar(x: Json, op: Opc): Json {
  if (Array.isArray(x)) return x.map((y) => limpiar(y, op));
  if (!esObj(x)) return x;
  const sinCifras = (e: Obj): Obj => ({ ...e, antes: null, despues: null, ...('valor_json' in e ? { valor_json: 'null' } : {}) });
  if (esEdicionDeCosto(x)) return sinCifras(x);
  // una cotización dice de quién es: sus costos de piezas son de su vendedor (y de Diego)
  if (op.usuario !== null && typeof x['vendedor_id'] === 'string' && 'borrador' in x) op = { ...op, propia: x['vendedor_id'] === op.usuario };
  if (!op.propia && esEdicion(x) && RUTA_COSTO_PIEZAS.test(String(x['ruta']))) {
    // la captura completa: sin sus costos; un costo: sin antes ni después
    if (x['ruta'] === '/piezas') return { ...x, antes: esObj(x['antes']) ? piezasSinCostos(x['antes']) : x['antes'], despues: esObj(x['despues']) ? piezasSinCostos(x['despues']) : x['despues'], ...('valor_json' in x ? { valor_json: 'null' } : {}) };
    return sinCifras(x);
  }
  const conSemaforo = op.semaforo;
  const o: Obj = {};
  for (const [k, v] of Object.entries(x)) {
    if (k === 'semaforo_margen') {
      // El color solo lo conserva un interno, y solo si es un color (nada más viaja en este campo).
      if (conSemaforo && (v === null || (typeof v === 'string' && COLORES.includes(v)))) o[k] = v;
      continue;
    }
    // Diego, 13-oct (junta): los precios límite del semáforo (contado con IVA para verde y amarillo) son PRECIOS, no costos:
    // los ve quien ve el color; sin semáforo (lo que va a la IA) no viajan (dicen el color sin decirlo).
    if (k === 'limites_precio' && !conSemaforo) continue;
    if (k === 'rentabilidad') {
      if (v === null) o[k] = null; // nivel sin precio: se queda null (así lo exige el esquema)
      // la rentabilidad de una opción o nivel: fuera. Al interno le queda SOLO el color (sin %, costo, utilidad ni comisión).
      else if (conSemaforo && esObj(v) && typeof v['semaforo'] === 'string' && COLORES.includes(v['semaforo'])) o['semaforo_margen'] = v['semaforo'];
      continue;
    }
    if ((k === 'margen_pct' || k === 'utilidad_sin_iva') && 'folio' in x) continue; // registro del CRM
    // La comisión (de cada vendedor en la lista de usuarios, o la de una cotización en sus parámetros) también es de Diego.
    if (k === 'comision_pct' && (('correo' in x && 'rol' in x) || 'opciones_activas' in x)) continue;
    // Optimus: la casilla del usuario y el precio congelado de la cotización (comisiones y factor) son de Diego.
    if (k === 'optimus' && 'correo' in x && 'rol' in x) continue;
    if (k === 'precio_optimus' && 'opciones_activas' in x) continue;
    // VERDE DE ENTRADA (2-nov): lo que daría la tabla sin la regla y cuánto subió cada precio son de Diego: dicen cuánto se subió.
    if (k === 'contado_sin_regla' && 'contado_tabla' in x) continue;
    if (k === 'verde_congelado' && 'opciones_activas' in x) continue;
    if (k === 'minimos_verde' && 'calculado_en' in x) continue;
    if (k === 'costo_solarix_sin_iva' && esCostoAdicional(x)) {
      o[k] = null;
      continue;
    }
    if (k === 'avisos' && Array.isArray(v)) {
      // El amarillo de margen ("zona de alerta") a precio de tabla es ruido para el vendedor y le deja ver en qué zona
      // queda el margen: es de Diego (ataque del 11-oct). El ROJO se queda (dice solo "necesita el OK de Diego").
      // Etapa 2 (12-oct): el aviso de que el semáforo cambió de color al recalcular es semáforo: el interno lo ve (solo trae
      // colores); un externo (y la IA) no.
      o[k] = v
        .filter((a) => !(esObj(a) && esAviso(a) && (a['codigo'] === 'COSTO_SIN_CONFIRMAR' || (a['codigo'] === 'MARGEN_BAJO' && a['nivel'] !== 'rojo') || (a['codigo'] === 'SEMAFORO_CAMBIO' && !conSemaforo))))
        .map((a) => (esObj(a) && esAviso(a) ? (op.propia ? avisoSinCifras(a) : avisoPiezasSinCifras(avisoSinCifras(a))) : limpiar(a, op)));
      continue;
    }
    if (k === 'eventos' && Array.isArray(v)) {
      o[k] = v.map((e) => limpiar(esObj(e) && esEvento(e) ? eventoSinCifras(e, conSemaforo) : e, op));
      continue;
    }
    if (k === 'avisos_generador' && Array.isArray(v)) {
      // Etapa 2 (verificación adversarial): los renglones vienen como "[NOTA] Aviso amarillo · SEMAFORO_CAMBIO …": el filtro
      // de antes buscaba "Revisión de rentabilidad" al PRINCIPIO y dejaba pasar el semáforo y la zona de alerta.
      o[k] = v.filter((s) => typeof s !== 'string' || !(notaSoloDirector(s, { semaforo: conSemaforo }) || (!op.propia && AVISO_COSTO_PIEZAS.test(s))));
      continue;
    }
    // los supuestos del resultado que son solo de Diego («Para Diego: …»)
    if (k === 'supuestos' && Array.isArray(v)) {
      o[k] = v.filter((s) => typeof s !== 'string' || !PARA_DIEGO.test(s)).map((y) => limpiar(y, op));
      continue;
    }
    if (k === 'revision_ia' && esObj(v) && esRevisionIA(v)) {
      o[k] = { ...v, resumen: RESUMEN_REVISION[String(v['veredicto'])] ?? 'El detalle de la revisión de precio lo ve Diego.' };
      continue;
    }
    // Ampliación de baterías: el cálculo sin lo que es de Diego (un solo criterio: calculoSinCostos, el que usa la pantalla).
    // ADENDA z59 (P2): la lista de compra (costos, meta, techo) es de Diego: el detalle de una Ganada la trae solo para él.
    if (k === 'lista_compra') continue;
    if (k === 'calculo_piezas' && esObj(v)) {
      o[k] = Array.isArray(v['partidas']) ? calculoSinCostos(v as unknown as CalculoAmpliacion) : null;
      continue;
    }
    // y la captura de una ajena, sin los costos que tecleó su vendedor
    if (k === 'piezas' && esObj(v) && 'costo_bateria' in v && !op.propia) {
      o[k] = piezasSinCostos(v);
      continue;
    }
    o[k] = limpiar(v, op);
  }
  return o;
}

/** La misma respuesta sin costos, márgenes ni utilidad (para quien no tiene `ver_costos`). No modifica la original.
 *  `semaforo: true` (asesor interno, permiso `ver_semaforo`): deja SOLO el color del semáforo (`semaforo_margen`) en cada
 *  opción, nivel y registro del CRM. Por omisión no deja ningún color (externos, y lo que se le manda a la IA). */
/*  `quien` (el servidor lo pasa SIEMPRE, http/registro.ts): quién pide y el vendedor de la cotización de la ruta
 *  (/api/cotizaciones/:id…; null si la ruta no es de una cotización). Con él, los costos de piezas de una ampliación solo le
 *  quedan a su vendedor: el historial y las versiones no dicen de quién son (se toma el de la ruta) y una cotización dentro de
 *  la respuesta lo dice ella (vendedor_id). Sin `quien`, no se mira de quién es. */
export function vistaSinCostos<T>(respuesta: T, opciones: { semaforo?: boolean; quien?: { usuario_id: string; vendedor_id: string | null } } = {}): T {
  const q = opciones.quien ?? null;
  return limpiar(respuesta, { semaforo: opciones.semaforo === true, usuario: q?.usuario_id ?? null, propia: q === null || q.vendedor_id === q.usuario_id }) as T;
}

/** ¿Esta respuesta trae algún costo TECLEADO de una ampliación (piezas: costo de proveedor, material, instalación, viáticos; sus
 *  ediciones con cifras; sus avisos con la cifra)? Candado de las pruebas: lo que recibe un asesor de una ampliación AJENA, false. */
export function traeCostosDePiezas(x: Json): boolean {
  if (typeof x === 'string') return false;
  if (Array.isArray(x)) return x.some(traeCostosDePiezas);
  if (!esObj(x)) return false;
  if (esEdicion(x) && RUTA_COSTO_PIEZAS.test(String(x['ruta'])) && x['ruta'] !== '/piezas' && ((x['antes'] ?? null) !== null || (x['despues'] ?? null) !== null)) return true;
  if (esAviso(x) && CAMPO_COSTO_PIEZAS.test(String(x['campo'] ?? '')) && CIFRA.test(String(x['mensaje']))) return true;
  for (const [k, v] of Object.entries(x)) {
    if (k === 'piezas' && esObj(v) && 'costo_bateria' in v) {
      if (COSTOS_PIEZAS.some((c) => (v[c] ?? null) !== null)) return true;
      if (esObj(v['costo_bateria']) && v['costo_bateria']['origen'] !== 'tabla') return true;
    }
    if (k === 'avisos_generador' && Array.isArray(v) && v.some((s) => typeof s === 'string' && AVISO_COSTO_PIEZAS.test(s))) return true;
    if (traeCostosDePiezas(v)) return true;
  }
  return false;
}

/** ¿Esta respuesta trae algún color del semáforo? (candado de las pruebas: la de un externo, false). */
export function traeSemaforo(x: Json): boolean {
  // Etapa 2 (verificación adversarial): también dicho en TEXTO (avisos del generador, notas, historial): antes solo veía el
  // aviso como objeto y el candado no tronaba con "[NOTA] Aviso amarillo · SEMAFORO_CAMBIO …".
  if (typeof x === 'string') return SEMAFORO_EN_TEXTO.test(x);
  if (Array.isArray(x)) return x.some(traeSemaforo);
  if (!esObj(x)) return false;
  for (const [k, v] of Object.entries(x)) {
    if (k === 'semaforo_margen' && v !== null && v !== undefined) return true;
    if (k === 'limites_precio' && v !== null && v !== undefined) return true;
    if (k === 'rentabilidad' && esObj(v) && 'semaforo' in v) return true;
    if (k === 'codigo' && v === 'SEMAFORO_CAMBIO' && esAviso(x)) return true;
    if (traeSemaforo(v)) return true;
  }
  return false;
}

/** Lo de `calculo_piezas` que solo ve el director (lo que quita calculoSinCostos). */
const CAMPOS_PIEZAS_DIRECTOR: readonly string[] = ['costo_total_sin_iva', 'comision_sin_iva', 'imprevistos_sin_iva', 'utilidad_sin_iva', 'margen_pct', 'regla'];

/** ¿Esta respuesta trae algo que solo ve el director? (las pruebas lo usan como candado: tras vistaSinCostos, false). */
export function traeCostos(x: Json): boolean {
  // Etapa 2 (verificación adversarial): también dicho en TEXTO (avisos del generador, .avisos.txt, notas del JSON v1).
  if (typeof x === 'string') return MARGEN_EN_TEXTO.test(x);
  if (Array.isArray(x)) return x.some(traeCostos);
  if (!esObj(x)) return false;
  if (esAviso(x) && x['codigo'] === 'MARGEN_BAJO' && x['nivel'] !== 'rojo') return true;
  for (const [k, v] of Object.entries(x)) {
    if (k === 'rentabilidad' && v !== null && v !== undefined) return true;
    if (k === 'lista_compra' && v !== undefined) return true;
    if ((k === 'contado_sin_regla' || k === 'verde_congelado' || k === 'minimos_verde') && v !== undefined) return true;
    if ((k === 'margen_pct' || k === 'utilidad_sin_iva') && 'folio' in x && v !== undefined) return true;
    if (k === 'comision_pct' && v !== undefined && v !== null && (('correo' in x && 'rol' in x) || 'opciones_activas' in x)) return true;
    if (k === 'optimus' && v !== undefined && 'correo' in x && 'rol' in x) return true;
    if (k === 'precio_optimus' && v !== undefined && 'opciones_activas' in x) return true;
    if (k === 'costo_solarix_sin_iva' && esCostoAdicional(x) && v !== null) return true;
    if (k === 'codigo' && v === 'COSTO_SIN_CONFIRMAR' && esAviso(x)) return true;
    if (esEdicionDeCosto(x) && ((x['antes'] ?? null) !== null || (x['despues'] ?? null) !== null)) return true;
    if (k === 'revision_ia' && esObj(v) && esRevisionIA(v) && CIFRA.test(String(v['resumen']))) return true;
    if (k === 'calculo_piezas' && esObj(v) && (CAMPOS_PIEZAS_DIRECTOR.some((c) => v[c] !== undefined) || (Array.isArray(v['partidas']) && v['partidas'].some((p) => esObj(p) && p['costo_unitario_sin_iva'] !== undefined)))) return true;
    if (traeCostos(v)) return true;
  }
  return false;
}
